/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IngestionPipelineStatus } from '../models/IngestionPipelineStatus';
import { IngestionSourceType } from '../models/IngestionSourceType';
import { S3SourceProperties } from '../models/S3SourceProperties';

export class IngestionPipeline {
  /**
  * The unique identifier of the ingestion pipeline
  */
  'id': string;
  /**
  * The name of the ingestion pipeline
  */
  'name': string;
  'sourceType': IngestionSourceType;
  's3SourceProperties'?: S3SourceProperties;
  'status': IngestionPipelineStatus;
  /**
  * The timestamp when the ingestion pipeline was created
  */
  'createdAt': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceType",
      "baseName": "sourceType",
      "type": "IngestionSourceType",
      "format": ""
    },
    {
      "name": "s3SourceProperties",
      "baseName": "s3SourceProperties",
      "type": "S3SourceProperties",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "IngestionPipelineStatus",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return IngestionPipeline.attributeTypeMap;
  }

  public constructor() {
  }
}



